<template>
  <MessagePopup :visible="visible">
    <template v-slot:content>
      <h3>{{ str('basePricePopup.title') }}</h3>
      <p class="message">
        {{ str('basePricePopup.text') }}
        <router-link
          :to="{ name: 'settings' }"
          class="button button--primary"
          @click.native="visible = false"
        >
          {{ str('basePricePopup.button') }}
        </router-link>
      </p>
    </template>
  </MessagePopup>
</template>

<script>
  import MessagePopup from '@/components/MessagePopup'

  export default {
    name: 'notifications-request-popup',
    components: {
      MessagePopup,
    },
    data() {
      return {
        visible: true,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .message {
    font-weight: $font-weight-base;

    a {
      margin-top: spacer(0.5);
      display: block;
    }
  }
</style>
